module.exports = __webpack_public_path__ + "static/buscando-ajuda-2-2faec57a259dbb3f74b76c6488819ca2.png";